"use client";

import { useEffect } from "react";
import { addRecentlyViewed } from "@/lib/recently-viewed";
import RecentlyViewed from "@/components/product/RecentlyViewed";

interface RecentlyViewedTrackerProps {
  slug: string;
}

/**
 * Client component that:
 * 1. Tracks the current product slug in localStorage on mount
 * 2. Renders the RecentlyViewed section (excluding the current product)
 *
 * Drop this into any server-rendered product detail page.
 */
export default function RecentlyViewedTracker({ slug }: RecentlyViewedTrackerProps) {
  useEffect(() => {
    addRecentlyViewed(slug);
  }, [slug]);

  return <RecentlyViewed currentSlug={slug} />;
}
